// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__39DEt","header":"PatientQuestionnaire_header__1DD0m","info":"PatientQuestionnaire_info__NI8iH"};